<template>
  <!-- <div> -->
  <div class="jingji-bottom">
    <ul>
      <li>
        <p>韩国东国大学</p>
        <div class="line"></div>
      </li>
      <li>
        <p>首尔校区：<span>大韩民国首尔特别市中区笔洞路1街30号</span></p>
      </li>
      <li>
        <p>京畿校区：<span>京畿道高阳市一山东区东国路32号</span></p>
      </li>
      <li>
        <p>庆州校区：<span>庆尚北道庆州市东大路123号</span></p>
      </li>
      <li>
        <p>海外校区：<span>美国洛杉矶</span></p>
      </li>
      <li>
        <p>韩国东国大学（中国）办公室</p>
        <div class="line"></div>
      </li>
      <li>
        <p>联系电话：<span>400-800-8772</span></p>
      </li>
      <li>
        <p class="botton">总部地址：<span>上海市人才大厦22楼(上海市静安区梅园路77号)</span></p>
      </li>
    </ul>
    <div class="hrdiv" style="height: 1px"></div>
    <!-- <div class="title">
   -2   <p>韩腾教育 版权所有</p>
      <a href="https://beian.miit.gov.cn/"> 沪ICP备2021009600号 </a>
    </div> -->
    <suspended></suspended>
  </div>
  <!-- </div> -->
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
import Suspended from '../components/Suspended.vue';
export default {
  components: { Suspended },
  data() {
    return {};
  },
  mouted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.jingji-bottom {
  letter-spacing: 3px;
  width: 100%;
  border-top: 1px solid #f2f2f2;
  // border-bottom: 1px solid #f2f2f2;
  // margin-bottom: 70px;
  background: #ffffff;
  ul {
    padding: 40px 30px;
    li {
      margin-top: 20px;
      p {
        font-size: 22px;
       
        font-weight: 700;
        color: #333333;
        span {
          font-weight: 400;
          color: #444444;
        }
      }
    }
    li:first-child {
      margin-top: 0px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 700;
      color: #333333;
      .line {
        width: 45px;
        margin-top: -9px;
        height: 4px;
        background: #f7901e;
      }
    }
    li:nth-child(2),
    li:nth-child(7) {
      margin-top: 30px;
    }
    li:nth-child(6) {
      margin-top: 40px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 700;
      color: #333333;
      .line {
        width: 45px;
        height: 4px;
        margin-top: -9px;
        background: #f7901e;
      }
    }
  }
  .hrdiv {
    width: 100%;
    // height: 1px;
    background: #f2f2f2;
    margin-bottom: 15px;
  }
  // .title {
  //   width: 100%;
  //   display: flex;
  //   justify-content: center;
  //   padding-bottom: 10px;
  //   p,
  //   a {
  //     font-size: 16px;
  //     font-family: Source Han Sans CN;
  //     font-weight: 400;
  //     color: #333333;
  //   }
  //   a {
  //     margin-left: 10px;
  //   }
  // }
  .botton{
    padding-bottom: 97px;
  }
}
</style>
